var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71429 4.76782H2.85V8.38391C2.85 8.78168 3.17143 9.10713 3.56429 9.10713H6.42143C6.81429 9.10713 7.13571 8.78168 7.13571 8.38391V4.76782H8.27143C8.90714 4.76782 9.22857 3.98674 8.77857 3.53111L5.5 0.211541C5.22143 -0.0705138 4.77143 -0.0705138 4.49286 0.211541L1.21429 3.53111C0.764286 3.98674 1.07857 4.76782 1.71429 4.76782ZM0 11.2768C0 11.6746 0.321429 12 0.714286 12H9.28571C9.67857 12 10 11.6746 10 11.2768C10 10.879 9.67857 10.5536 9.28571 10.5536H0.714286C0.321429 10.5536 0 10.879 0 11.2768Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFilled);
export default __webpack_public_path__ + "static/media/upload-filled.5038e9040af0a93d4bd15785d9e74e5c.svg";
export { ForwardRef as ReactComponent };